<div class="container" cdkFocusInitial aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1 mat-dialog-title>Sign & Certify Report</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form id="filter_form" class="filter_form" [formGroup]="form">
      <div class="whole-line">
        <mat-form-field appearance="outline">
          <mat-label>Signing on Behalf of</mat-label>
          <mat-select formControlName="behalfOf" required (selectionChange)="signChanged($event.value)">
            @for (option of signOptions; track option) {
            <mat-option [value]="option">{{option.name}}</mat-option>
            }
          </mat-select>
          <mat-error>Required Field</mat-error>
        </mat-form-field>
        <!-- <mat-form-field appearance="outline" *ngIf="forests.length > 0 && data.report.authorization_status_id == 0">
        <mat-label>{{ areaName }}</mat-label>
        <mat-select formControlName="forest" multiple required>
          @for (option of forests; track option) {
            <mat-option [value]="option">{{option.name}}</mat-option>
          }
        </mat-select>
        <mat-error>Required Field</mat-error>
      </mat-form-field> -->
      </div>
      <div class="whole-line">
        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="first_name" required aria-label="Fire or Complex Name">
          <mat-error>Required Field</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="last_name" required aria-label="Fire or Complex Name">
          <mat-error>Required Field</mat-error>
        </mat-form-field>
      </div>
      @if (this.data.signType == 'LO') {
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <mat-select formControlName="title" required aria-label="signer title">
          @if ((this.form.value.behalfOf?.name ?? '') == 'Myself') {
          <mat-option value="Forest Supervisor">Forest Supervisor</mat-option>
          }
          <mat-option value="Acting Forest Supervisor">Acting Forest Supervisor</mat-option>
        </mat-select>
        <mat-error>Required Field</mat-error>
      </mat-form-field>
      }
      @if (this.data.signType == 'RO') {
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <mat-select formControlName="title" required aria-label="signer title">
          @if ((this.form.value.behalfOf?.name ?? '') == 'Myself') {
          <mat-option value="Regional Forester">Regional Forester</mat-option>
          }
          <mat-option value="Acting Regional Forester">Acting Regional Forester</mat-option>
          <mat-option value="Deputy Regional Forester">Deputy Regional Forester</mat-option>
          <mat-option value="Acting Deputy Regional Forester">Acting Deputy Regional Forester</mat-option>
        </mat-select>
        <mat-error>Required Field</mat-error>
      </mat-form-field>
      <div class="whole-line support-warning">
        <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
        <div class="support-text">
          <span class="support-title">
            By signing, you attest that you have the proper delegated authority.
          </span>
        </div>
      </div>
      }
      @if (this.data.signType == 'WO') {
      <mat-form-field appearance="outline" style="flex: 100%; max-width: 93%;">
        <mat-label>Title</mat-label>
        <mat-select formControlName="title" required aria-label="signer title">
          @if ((this.form.value.behalfOf?.name ?? '') == 'Myself') {
          <mat-option value="Director, National Water Resources and Post-Fire Recovery">Director, National Water
            Resources and Post-Fire Recovery</mat-option>
          }
          <mat-option value="Acting Director, National Water Resources and Post-Fire Recovery">Acting Director, National
            Water Resources and Post-Fire Recovery</mat-option>
        </mat-select>
        <mat-error>Required Field</mat-error>
      </mat-form-field>
      }

      <div class="whole-line">
        <mat-checkbox formControlName="confirm">
          @if (this.data.signType == 'LO') {
          <span>I certify that I have thoroughly reviewed the 2500-8 BAER report for {{ this.data.report.baer_name }}.
            The report is approved for submission to the regional office for funding recommendations.</span>
          }
          @if (this.data.signType == 'RO') {
          <span>I certify that I have reviewed the BAER report and the regional funding recommendations. The
            recommendations are authorized for funding.</span>
          }
          @if (this.data.signType == 'WO') {
          <span>I certify that I have reviewed the BAER report and the WO funding recommendations. The recommendations
            are authorized for funding.</span>
          }
        </mat-checkbox>
      </div>
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row">
      <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      <button class="usa-button" [disabled]="!form.valid" (click)="sign()">Submit</button>
    </div>
  </div>
</div>